import React, { createContext, useState } from "react";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [password, setPassword] = useState("");

  const correctPassword = "CMH@2025"; // change as needed

  // 🔐 OPEN LOGIN
  const login = () => {
    setShowLoginModal(true);
  };

  // 🔓 OPEN LOGOUT CONFIRMATION
  const logout = () => {
    setShowLogoutConfirm(true);
  };

  // ✔ FINAL LOGOUT AFTER CONFIRM
  const confirmLogout = () => {
    setIsAdmin(false);
    setShowLogoutConfirm(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password === correctPassword) {
        setIsAdmin(true);
        setShowLoginModal(false);
        setPassword("");
    } else {
        alert("Incorrect Password");
    }
  };

  return (
    <AdminContext.Provider value={{ isAdmin, login, logout }}>
      {children}

      {/* --------------------
          ADMIN LOGIN MODAL
      -------------------- */}
      {showLoginModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal">
            <h2>Admin Login</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="password"
                placeholder="Enter Admin Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="admin-input"
              />

              <button type="submit" className="admin-submit-btn">
                Login
              </button>
            </form>

            <button
              className="admin-close-btn"
              onClick={() => setShowLoginModal(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* ----------------------------
          LOGOUT CONFIRMATION MODAL
      ---------------------------- */}
      {showLogoutConfirm && (
        <div className="admin-modal-overlay">
          <div className="admin-modal">
            <h3>Are you sure you want to logout?</h3>

            <div className="logout-buttons">
              <button className="admin-submit-btn" onClick={confirmLogout}>
                Yes, Logout
              </button>

              <button
                className="admin-cancel-btn"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
            </div>

            <button
              className="admin-close-btn"
              onClick={() => setShowLogoutConfirm(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </AdminContext.Provider>
  );
};
